import { Spinner, theme, Typography } from '@/design-system';

import { LiveStatus, StatusRow } from './send-recipient-combobox.styled';

export interface SendRecipientStatusProps {
  isSearching: boolean;
  showEmpty: boolean;
  showSearchError: boolean;
}

export const getSendRecipientStatusCopy = ({
  isSearching,
  showEmpty,
  showSearchError,
}: SendRecipientStatusProps): string => {
  if (isSearching) return 'Searching contacts';
  if (showSearchError) {
    return 'Contact lookup is unavailable. You can still enter a Sui address.';
  }
  if (showEmpty) return 'No contacts with a wallet found';
  return '';
};

export const SendRecipientLiveStatus = ({ message }: { message: string }) => (
  <LiveStatus data-slot="send-recipient-live-status">{message}</LiveStatus>
);

export const SendRecipientPopupStatus = ({
  isSearching,
  message,
}: {
  isSearching: boolean;
  message: string;
}) =>
  message ? (
    <StatusRow data-slot="send-recipient-visible-status">
      {isSearching ? <Spinner /> : null}
      <Typography as="span" variant="body3" color={theme.colors.text.secondary}>
        {message}
      </Typography>
    </StatusRow>
  ) : null;
